module.exports = {
    colorCodes: [
        {
            RAL: "1000",
            RGB: "190-189-127",
            HEX: "#BEBD7F",
            de: "Grünbeige",
            en: "Green beige",
            fr: "Beige vert",
            sp: "Beige verdoso",
            it: "Beige verdastro",
            nl: "Groenbeige",
        },
        {
            RAL: "1001",
            RGB: "194-176-120",
            HEX: "#C2B078",
            de: "Beige",
            en: "Beige",
            fr: "Beige",
            sp: "Beige",
            it: "Beige",
            nl: "Beige",
        },
        {
            RAL: "1002",
            RGB: "198-166-100",
            HEX: "#C6A664",
            de: "Sandgelb",
            en: "Sand yellow",
            fr: "Jaune sable",
            sp: "Amarillo arena",
            it: "Giallo sabbia",
            nl: "Zandgeel",
        },
        {
            RAL: "1003",
            RGB: "229-190-001",
            HEX: "#E5BE01",
            de: "Signalgelb",
            en: "Signal yellow",
            fr: "Jaune de sécurité",
            sp: "Amarillo señales",
            it: "Giallo segnale",
            nl: "Signaalgeel",
        },
        {
            RAL: "1004",
            RGB: "205-164-052",
            HEX: "#CDA434",
            de: "Goldgelb",
            en: "Golden yellow",
            fr: "Jaune or",
            sp: "Amarillo oro",
            it: "Giallo oro",
            nl: "Goudgeel",
        },
        {
            RAL: "1005",
            RGB: "169-131-007",
            HEX: "#A98307",
            de: "Honiggelb",
            en: "Honey yellow",
            fr: "Jaune miel",
            sp: "Amarillo miel",
            it: "Giallo miele",
            nl: "Honinggeel",
        },
        {
            RAL: "1006",
            RGB: "228-160-016",
            HEX: "#E4A010",
            de: "Maisgelb",
            en: "Maize yellow",
            fr: "Jaune maïs",
            sp: "Amarillo maiz",
            it: "Giallo polenta",
            nl: "Maisgeel",
        },
        {
            RAL: "1007",
            RGB: "220-156-000",
            HEX: "#DC9D00",
            de: "Narzissengelb",
            en: "Daffodil yellow",
            fr: "Jaune narcisse",
            sp: "Amarillo narciso",
            it: "Giallo narciso",
            nl: "Narcissengeel",
        },
        {
            RAL: "1011",
            RGB: "138-102-066",
            HEX: "#8A6642",
            de: "Braunbeige",
            en: "Brown beige",
            fr: "Beige brun",
            sp: "Beige pardo",
            it: "Beige marrone",
            nl: "Bruinbeige",
        },
        {
            RAL: "1012",
            RGB: "199-180-070",
            HEX: "#C7B446",
            de: "Zitronengelb",
            en: "Lemon yellow",
            fr: "Jaune citron",
            sp: "Amarillo limón",
            it: "Giallo limone",
            nl: "Citroengeel",
        },
        {
            RAL: "1013",
            RGB: "234-230-202",
            HEX: "#EAE6CA",
            de: "Perlweiß",
            en: "Oyster white",
            fr: "Blanc perlé",
            sp: "Blanco perla",
            it: "Bianco perla",
            nl: "Parelwit",
        },
        {
            RAL: "1014",
            RGB: "225-204-079",
            HEX: "#E1CC4F",
            de: "Elfenbein",
            en: "Ivory",
            fr: "Ivoire",
            sp: "Marfil",
            it: "Avorio",
            nl: "Ivoorkleurig",
        },
        {
            RAL: "1015",
            RGB: "230-214-144",
            HEX: "#E6D690",
            de: "Hellelfenbein",
            en: "Light ivory",
            fr: "Ivoire clair",
            sp: "Marfil claro",
            it: "Avorio chiaro",
            nl: "Licht ivoorkleurig",
        },
        {
            RAL: "1016",
            RGB: "237-255-033",
            HEX: "#EDFF21",
            de: "Schwefelgelb",
            en: "Sulfur yellow",
            fr: "Jaune soufre",
            sp: "Amarillo azufre",
            it: "Giallo zolfo",
            nl: "Zwavelgeel",
        },
        {
            RAL: "1017",
            RGB: "245-208-051",
            HEX: "#F5D033",
            de: "Safrangelb",
            en: "Saffron yellow",
            fr: "Jaune safran",
            sp: "Amarillo azafrán",
            it: "Giallo zafferano",
            nl: "Saffraangeel",
        },
        {
            RAL: "1018",
            RGB: "248-243-053",
            HEX: "#F8F32B",
            de: "Zinkgelb",
            en: "Zinc yellow",
            fr: "Jaune zinc",
            sp: "Amarillo de zinc",
            it: "Giallo zinco",
            nl: "Zinkgeel",
        },
        {
            RAL: "1019",
            RGB: "158-151-100",
            HEX: "#9E9764",
            de: "Graubeige",
            en: "Grey beige",
            fr: "Beige gris",
            sp: "Beige agrisado",
            it: "Beige grigiastro",
            nl: "Grijsbeige",
        },
        {
            RAL: "1020",
            RGB: "153-153-080",
            HEX: "#999950",
            de: "Olivgelb",
            en: "Olive yellow",
            fr: "Jaune olive",
            sp: "Amarillo oliva",
            it: "Giallo olivastro",
            nl: "Olijfgeel",
        },
        {
            RAL: "1021",
            RGB: "243-218-011",
            HEX: "#F3DA0B",
            de: "Rapsgelb",
            en: "Rape yellow",
            fr: "Jaune colza",
            sp: "Amarillo colza",
            it: "Giallo navone",
            nl: "Koolzaadgeel",
        },
        {
            RAL: "1023",
            RGB: "250-210-001",
            HEX: "#FAD201",
            de: "Verkehrsgelb",
            en: "Traffic yellow",
            fr: "Jaune signalisation",
            sp: "Amarillo tráfico",
            it: "Giallo traffico",
            nl: "Verkeersgeel",
        },
        {
            RAL: "1024",
            RGB: "174-160-075",
            HEX: "#AEA04B",
            de: "Ockergelb",
            en: "Ochre yellow",
            fr: "Jaune ocre",
            sp: "Amarillo ocre",
            it: "Giallo ocra",
            nl: "Okergeel",
        },
        /*{
        RAL: "1026",
        RGB: "255-255-000",
        HEX: "#FFFF00",
        de: "Leuchtgelb",
        en: "Luminous yellow",
        fr: "Jaune brillant",
        sp: "Amarillo brillante",
        it: "Giallo brillante",
        nl: "Briljantgeel",
    },*/
        {
            RAL: "1027",
            RGB: "157-145-001",
            HEX: "#9D9101",
            de: "Currygelb",
            en: "Curry",
            fr: "Jaune curry",
            sp: "Amarillo curry",
            it: "Giallo curry",
            nl: "Kerriegeel",
        },
        {
            RAL: "1028",
            RGB: "244-169-000",
            HEX: "#F4A900",
            de: "Melonengelb",
            en: "Melon yellow",
            fr: "Jaune melon",
            sp: "Amarillo melón",
            it: "Giallo melone",
            nl: "Meloengeel",
        },
        {
            RAL: "1032",
            RGB: "214-174-001",
            HEX: "#D6AE01",
            de: "Ginstergelb",
            en: "Broom yellow",
            fr: "Jaune genêt",
            sp: "Amarillo retama",
            it: "Giallo scopa",
            nl: "Bremgeel",
        },
        {
            RAL: "1033",
            RGB: "243-165-005",
            HEX: "#F3A505",
            de: "Dahliengelb",
            en: "Dahlia yellow",
            fr: "Jaune dahlia",
            sp: "Amarillo dalia",
            it: "Giallo dahlien",
            nl: "Dahliageel",
        },
        {
            RAL: "1034",
            RGB: "239-169-074",
            HEX: "#EFA94A",
            de: "Pastellgelb",
            en: "Pastel yellow",
            fr: "Jaune pastel",
            sp: "Amarillo pastel",
            it: "Giallo pastello",
            nl: "Pastelgeel",
        },
        {
            RAL: "1035",
            RGB: "106-093-077",
            HEX: "#6A5D4D",
            de: "Perlbeige",
            en: "Pearl beige",
            fr: "Beige nacré",
            sp: "Beige perlado",
            it: "Beige perlato",
            nl: "Parelmoergrijs",
        },
        /*{
        RAL: "1036",
        RGB: "112-083-053",
        HEX: "#705335",
        de: "Perlgold",
        en: "Pearl gold",
        fr: "Or nacré",
        sp: "Oro perlado",
        it: "Oro perlato",
        nl: "Parelmoergoud",
    },*/
        {
            RAL: "1037",
            RGB: "243-159-024",
            HEX: "#F39F18",
            de: "Sonnengelb",
            en: "Sun yellow",
            fr: "Jaune soleil",
            sp: "Amarillo sol",
            it: "Giallo sole",
            nl: "Zonnegeel",
        },
        {
            RAL: "2000",
            RGB: "237-118-014",
            HEX: "#ED760E",
            de: "Gelborange",
            en: "Yellow orange",
            fr: "Orangé jaune",
            sp: "Amarillo naranja",
            it: "Arancio giallastro",
            nl: "Geeloranje",
        },
        {
            RAL: "2001",
            RGB: "201-060-032",
            HEX: "#C93C20",
            de: "Rotorange",
            en: "Red orange",
            fr: "Orangé rouge",
            sp: "Rojo anaranjado",
            it: "Arancio rossastro",
            nl: "Roodoranje",
        },
        {
            RAL: "2002",
            RGB: "203-040-033",
            HEX: "#CB2821",
            de: "Blutorange",
            en: "Vermilion",
            fr: "Orangé sang",
            sp: "Naranja sanguineo",
            it: "Arancio sanguigno",
            nl: "Vermiljoen",
        },
        {
            RAL: "2003",
            RGB: "255-117-020",
            HEX: "#FF7514",
            de: "Pastellorange",
            en: "Pastel orange",
            fr: "Orangé pastel",
            sp: "Naranja pálido",
            it: "Arancio pastello",
            nl: "Pasteloranje",
        },
        {
            RAL: "2004",
            RGB: "244-070-017",
            HEX: "#F44611",
            de: "Reinorange",
            en: "Pure orange",
            fr: "Orangé pur",
            sp: "Naranja puro",
            it: "Arancio puro",
            nl: "Zuiver oranje",
        },
        /*{
        RAL: "2005",
        RGB: "255-035-001",
        HEX: "#FF2301",
        de: "Leuchtorange",
        en: "Luminous orange",
        fr: "Orangé brillant",
        sp: "Naranja brillante",
        it: "Arancio brillante",
        nl: "Briljant oranje",
    },*/
        /*{
        RAL: "2007",
        RGB: "255-164-032",
        HEX: "#FFA420",
        de: "Leuchthellorange",
        en: "Luminous bright orange",
        fr: "Orangé clair rillant",
        sp: "Naranja claro brillante",
        it: "Arancio chiaro brillante",
        nl: "Briljant lichtoranje",
    },*/
        {
            RAL: "2008",
            RGB: "247-094-037",
            HEX: "#F75E25",
            de: "Hellrotorange",
            en: "Bright red orange",
            fr: "Orangé rouge clair",
            sp: "Rojo claro anaranjado",
            it: "Rosso arancio chiaro",
            nl: "Licht roodoranje",
        },
        {
            RAL: "2009",
            RGB: "245-064-033",
            HEX: "#F54021",
            de: "Verkehrsorange",
            en: "Traffic orange",
            fr: "Orangé signalisation",
            sp: "Naranja tráfico",
            it: "Arancio traffico",
            nl: "Verkeersoranje",
        },
        {
            RAL: "2010",
            RGB: "216-075-032",
            HEX: "#D84B20",
            de: "Signalorange",
            en: "Signal orange",
            fr: "Orangé de sécurité",
            sp: "Naranja señales",
            it: "Arancio segnale",
            nl: "Signaaloranje",
        },
        {
            RAL: "2011",
            RGB: "236-124-038",
            HEX: "#EC7C26",
            de: "Tieforange",
            en: "Deep orange",
            fr: "Orangé foncé",
            sp: "Naranja intenso",
            it: "Arancio profondo",
            nl: "Dieporanje",
        },
        {
            RAL: "2012",
            RGB: "235-106-014",
            HEX: "#E55137",
            de: "Lachsorange",
            en: "Salmon range",
            fr: "Orangé saumon",
            sp: "Naranja salmón",
            it: "Arancio salmone",
            nl: "Zalmoranje",
        },
        /*{
        RAL: "2013",
        RGB: "195-088-049",
        HEX: "#C35831",
        de: "Perlorange",
        en: "Pearl orange",
        fr: "Orangé nacré",
        sp: "Naranja perlado",
        it: "Arancio perlato",
        nl: "Parelmoeroranje",
    },*/
        {
            RAL: "3000",
            RGB: "175-043-030",
            HEX: "#AF2B1E",
            de: "Feuerrot",
            en: "Flame red",
            fr: "Rouge feu",
            sp: "Rojo vivo",
            it: "Rosso fuoco",
            nl: "Vuurrood",
        },
        {
            RAL: "3001",
            RGB: "165-032-025",
            HEX: "#A52019",
            de: "Signalrot",
            en: "Signal red",
            fr: "Rouge de sécurité",
            sp: "Rojo señales",
            it: "Rosso  segnale",
            nl: "Signaalrood",
        },
        {
            RAL: "3002",
            RGB: "162-035-029",
            HEX: "#A2231D",
            de: "Karminrot",
            en: "Carmine red",
            fr: "Rouge carmin",
            sp: "Rojo carmin",
            it: "Rosso carminio",
            nl: "Karmijnrood",
        },
        {
            RAL: "3003",
            RGB: "155-017-030",
            HEX: "#9B111E",
            de: "Rubinrot",
            en: "Ruby red",
            fr: "Rouge rubis",
            sp: "Rojo rubí",
            it: "Rosso rubino",
            nl: "Robijnrood",
        },
        {
            RAL: "3004",
            RGB: "117-021-030",
            HEX: "#75151E",
            de: "Purpurrot",
            en: "Purple red",
            fr: "Rouge pourpre",
            sp: "Rojo purpura",
            it: "Rosso porpora",
            nl: "Purperrood",
        },
        {
            RAL: "3005",
            RGB: "094-033-041",
            HEX: "#5E2129",
            de: "Weinrot",
            en: "Wine red",
            fr: "Rouge vin",
            sp: "Rojo vino",
            it: "Rosso vino",
            nl: "Wijnrood",
        },
        {
            RAL: "3007",
            RGB: "065-034-039",
            HEX: "#412227",
            de: "Schwarzrot",
            en: "Black red",
            fr: "Rouge noir",
            sp: "Rojo negruzco",
            it: "Rosso nerastro",
            nl: "Zwartrood",
        },
        {
            RAL: "3009",
            RGB: "100-036-036",
            HEX: "#642424",
            de: "Oxidrot",
            en: "Oxide red",
            fr: "Rouge oxyde",
            sp: "Rojo óxido",
            it: "Rosso  ossido",
            nl: "Oxyderood",
        },
        {
            RAL: "3011",
            RGB: "120-031-025",
            HEX: "#781F19",
            de: "Braunrot",
            en: "Brown red",
            fr: "Rouge brun",
            sp: "Rojo pardo",
            it: "Rosso marrone",
            nl: "Bruinrood",
        },
        {
            RAL: "3012",
            RGB: "193-135-107",
            HEX: "#C1876B",
            de: "Beigerot",
            en: "Beige red",
            fr: "Rouge beige",
            sp: "Rojo beige",
            it: "Rosso beige",
            nl: "Beigerood",
        },
        {
            RAL: "3013",
            RGB: "161-035-018",
            HEX: "#A12312",
            de: "Tomatenrot",
            en: "Tomato red",
            fr: "Rouge tomate",
            sp: "Rojo tomate",
            it: "Rosso pomodoro",
            nl: "Tomaatrood",
        },
        {
            RAL: "3014",
            RGB: "211-110-112",
            HEX: "#D36E70",
            de: "Altrosa",
            en: "Antique pink",
            fr: "Vieux rose",
            sp: "Rojo viejo",
            it: "Rosa antico",
            nl: "Oudroze",
        },
        {
            RAL: "3015",
            RGB: "234-137-154",
            HEX: "#EA899A",
            de: "Hellrosa",
            en: "Light pink",
            fr: "Rose clair",
            sp: "Rosa claro",
            it: "Rosa chiaro",
            nl: "Lichtroze",
        },
        {
            RAL: "3016",
            RGB: "179-040-033",
            HEX: "#B32821",
            de: "Korallenrot",
            en: "Coral red",
            fr: "Rouge corail",
            sp: "Rojo coral",
            it: "Rosso corallo",
            nl: "Koraalrood",
        },
        {
            RAL: "3017",
            RGB: "230-050-068",
            HEX: "#E63244",
            de: "Rosé",
            en: "Rose",
            fr: "Rosé",
            sp: "Rosa",
            it: "Rosato",
            nl: "Bleekrood",
        },
        {
            RAL: "3018",
            RGB: "213-048-050",
            HEX: "#D53032",
            de: "Erdbeerrot",
            en: "Strawberry red",
            fr: "Rouge fraise",
            sp: "Rojo fresa",
            it: "Rosso fragola",
            nl: "Aardbeirood",
        },
        {
            RAL: "3020",
            RGB: "204-006-005",
            HEX: "#CC0605",
            de: "Verkehrsrot",
            en: "Traffic red",
            fr: "Rouge signalisation",
            sp: "Rojo tráfico",
            it: "Rosso traffico",
            nl: "Verkeersrood",
        },
        {
            RAL: "3022",
            RGB: "217-080-048",
            HEX: "#D95030",
            de: "Lachsrot",
            en: "Salmon pink",
            fr: "Rouge saumon",
            sp: "Rojo salmón",
            it: "Rosso salmone",
            nl: "Zalmrood",
        },
        /*{
        RAL: "3024",
        RGB: "248-000-000",
        HEX: "#F80000",
        de: "Leuchtrot",
        en: "Luminous red",
        fr: "Rouge brillant",
        sp: "Rojo brillante",
        it: "Rosso brillante",
        nl: "Briljantrood",
    },*/
        /*{
        RAL: "3026",
        RGB: "254-000-000",
        HEX: "#FE0000",
        de: "Leuchthellrot",
        en: "Luminous bright red",
        fr: "Rouge clair brillant",
        sp: "Rojo claro brillante",
        it: "Rosso chiaro brillante",
        nl: "Briljant lichtrood",
    },*/
        {
            RAL: "3027",
            RGB: "197-029-052",
            HEX: "#C51D34",
            de: "Himbeerrot",
            en: "Raspberry red",
            fr: "Rouge framboise",
            sp: "Rojo frambuesa",
            it: "Rosso lampone",
            nl: "Framboosrood",
        },
        /*{
        RAL: "3028",
        RGB: "203-050-052",
        HEX: "#CB3234",
        de: "Reinrot",
        en: "Pure  red",
        fr: "Rouge puro",
        sp: "Rojo puro",
        it: "Rosso puro",
        nl: "Zuiverrood",
    },*/
        {
            RAL: "3031",
            RGB: "179-036-040",
            HEX: "#B32428",
            de: "Orientrot",
            en: "Orient red",
            fr: "Rouge oriental",
            sp: "Rojo oriente",
            it: "Rosso oriente",
            nl: "Oriëntrood",
        },
        /*{
        RAL: "3032",
        RGB: "114-020-034",
        HEX: "#721422",
        de: "Perlrubinrot",
        en: "Pearl ruby red",
        fr: "Rouge rubis nacré",
        sp: "Rojo rubí perlado",
        it: "Rosso rubino perlato",
        nl: "Parelmoer-donkerrood",
    },*/
        /*{
        RAL: "3033",
        RGB: "180-076-067",
        HEX: "#B44C43",
        de: "Perlrosa",
        en: "Pearl pink",
        fr: "Rose nacré",
        sp: "Rosa perlado",
        it: "Rosa perlato",
        nl: "Parelmoer-lichtrood",
    },*/
        {
            RAL: "4001",
            RGB: "222-076-138",
            HEX: "#6D3F5B",
            de: "Rotlila",
            en: "Red lilac",
            fr: "Lilas rouge",
            sp: "Rojo lila",
            it: "Lilla rossastro",
            nl: "Roodlila",
        },
        {
            RAL: "4002",
            RGB: "146-043-062",
            HEX: "#922B3E",
            de: "Rotviolett",
            en: "Red violet",
            fr: "Violet rouge",
            sp: "Rojo violeta",
            it: "Viola rossastro",
            nl: "Roodpaars",
        },
        {
            RAL: "4003",
            RGB: "222-076-138",
            HEX: "#DE4C8A",
            de: "Erikaviolett",
            en: "Heather violet",
            fr: "Violet bruyère",
            sp: "Violeta érica",
            it: "Viola erica",
            nl: "Heidepaars",
        },
        {
            RAL: "4004",
            RGB: "110-028-052",
            HEX: "#641C34",
            de: "Bordeauxviolett",
            en: "Claret violet",
            fr: "Violet bordeaux",
            sp: "Burdeos",
            it: "Viola bordeaux",
            nl: "Bordeauxpaars",
        },
        {
            RAL: "4005",
            RGB: "108-070-117",
            HEX: "#6C4675",
            de: "Blaulila",
            en: "Blue lilac",
            fr: "Lilas bleu",
            sp: "Lila azulado",
            it: "Lilla bluastro",
            nl: "Blauwlila",
        },
        {
            RAL: "4006",
            RGB: "160-052-114",
            HEX: "#A03472",
            de: "Verkehrspurpur",
            en: "Traffic purple",
            fr: "Pourpre signalisation",
            sp: "Púrpurá tráfico",
            it: "Porpora traffico",
            nl: "Verkeerspurper",
        },
        {
            RAL: "4007",
            RGB: "074-025-044",
            HEX: "#4A192C",
            de: "Purpurviolett",
            en: "Purple violet",
            fr: "Violet pourpre",
            sp: "Violeta púrpura",
            it: "Porpora violetto",
            nl: "Purperviolet",
        },
        {
            RAL: "4008",
            RGB: "144-070-132",
            HEX: "#924E7D",
            de: "Signalviolett",
            en: "Signal violet",
            fr: "Violet de sécurité",
            sp: "Violeta señales",
            it: "Violetto segnale",
            nl: "Signaalviolet",
        },
        {
            RAL: "4009",
            RGB: "164-125-144",
            HEX: "#A18594",
            de: "Pastellviolett",
            en: "Pastel violet",
            fr: "Violet pastel",
            sp: "Violeta pastel",
            it: "Violetto pastello",
            nl: "Pastelviolet",
        },
        {
            RAL: "4010",
            RGB: "215-045-109",
            HEX: "#CF3476",
            de: "Telemagenta",
            en: "Telemagenta",
            fr: "Telemagenta",
            sp: "Magenta tele",
            it: "Tele Magenta",
            nl: "Telemagenta",
        },
        /*{
        RAL: "4011",
        RGB: "134-115-161",
        HEX: "#8673A1",
        de: "Perlviolett",
        en: "Pearl violet",
        fr: "Violet nacré",
        sp: "Violeta perlado",
        it: "Violetto perlato",
        nl: "Parelmoer-donkerviolet",
    },*/
        /*{
        RAL: "4012",
        RGB: "108-104-129",
        HEX: "#6C6874",
        de: "Perlbrombeer",
        en: "Pearl black berry",
        fr: "Mûre nacré",
        sp: "Morado perlado",
        it: "Mora perlato",
        nl: "Parelmoer-lichtviolet",
    },*/
        {
            RAL: "5000",
            RGB: "042-046-075",
            HEX: "#354D73",
            de: "Violettblau",
            en: "Violet blue",
            fr: "Bleu violet",
            sp: "Azul violeta",
            it: "Blu violaceo",
            nl: "Paarsblauw",
        },
        {
            RAL: "5001",
            RGB: "031-052-056",
            HEX: "#1F3438",
            de: "Grünblau",
            en: "Green blue",
            fr: "Bleu vert",
            sp: "Azul verdoso",
            it: "Blu verdastro",
            nl: "Groenblauw",
        },
        {
            RAL: "5002",
            RGB: "032-033-079",
            HEX: "#20214F",
            de: "Ultramarinblau",
            en: "Ultramarine blue",
            fr: "Bleu outremer",
            sp: "Azul ultramar",
            it: "Blu oltremare",
            nl: "Ultramarijnblauw",
        },
        {
            RAL: "5003",
            RGB: "029-030-051",
            HEX: "#1D1E33",
            de: "Saphirblau",
            en: "Saphire blue",
            fr: "Bleu saphir",
            sp: "Azul zafiro",
            it: "Blu zaffiro",
            nl: "Saffierblauw",
        },
        {
            RAL: "5004",
            RGB: "032-033-079",
            HEX: "#18171C",
            de: "Schwarzblau",
            en: "Black blue",
            fr: "Bleu noir",
            sp: "Azul negruzco",
            it: "Blu nerastro",
            nl: "Zwartblauw",
        },
        {
            RAL: "5005",
            RGB: "030-045-110",
            HEX: "#1E2460",
            de: "Signalblau",
            en: "Signal blue",
            fr: "Bleu de sécurité",
            sp: "Azul señales",
            it: "Blu segnale",
            nl: "Signaalblauw",
        },
        {
            RAL: "5007",
            RGB: "062-095-138",
            HEX: "#3E5F8A",
            de: "Brillantblau",
            en: "Brillant blue",
            fr: "Bleu brillant",
            sp: "Azul brillante",
            it: "Blu brillante",
            nl: "Briljantblauw",
        },
        {
            RAL: "5008",
            RGB: "038-037-045",
            HEX: "#26252D",
            de: "Graublau",
            en: "Grey blue",
            fr: "Bleu gris",
            sp: "Azul grisáceo",
            it: "Blu grigiastro",
            nl: "Grijsblauw",
        },
        {
            RAL: "5009",
            RGB: "002-086-105",
            HEX: "#025669",
            de: "Azurblau",
            en: "Azure blue",
            fr: "Bleu azur",
            sp: "Azul azur",
            it: "Blu  azzurro",
            nl: "Azuurblauw",
        },
        {
            RAL: "5010",
            RGB: "014-041-075",
            HEX: "#0E294B",
            de: "Enzianblau",
            en: "Gentian blue",
            fr: "Bleu gentiane",
            sp: "Azul genciana",
            it: "Blu  genziana",
            nl: "Gentiaanblauw",
        },
        {
            RAL: "5011",
            RGB: "035-026-036",
            HEX: "#231A24",
            de: "Stahlblau",
            en: "Steel blue",
            fr: "Bleu acier",
            sp: "Azul acero",
            it: "Blu acciaio",
            nl: "Staalblauw",
        },
        {
            RAL: "5012",
            RGB: "059-131-189",
            HEX: "#3B83BD",
            de: "Lichtblau",
            en: "Light blue",
            fr: "Bleu clair",
            sp: "Azul luminoso",
            it: "Blu luce",
            nl: "Lichtblauw",
        },
        {
            RAL: "5013",
            RGB: "037-041-074",
            HEX: "#1E213D",
            de: "Kobaltblau",
            en: "Cobalt blue",
            fr: "Bleu cobalt",
            sp: "Azul cobalto",
            it: "Blu cobalto",
            nl: "Kobaltblauw",
        },
        {
            RAL: "5014",
            RGB: "096-111-140",
            HEX: "#606E8C",
            de: "Taubenblau",
            en: "Pigeon blue",
            fr: "Bleu pigeon",
            sp: "Azul olombino",
            it: "Blu colomba",
            nl: "Duifblauw",
        },
        {
            RAL: "5015",
            RGB: "034-113-179",
            HEX: "#2271B3",
            de: "Himmelblau",
            en: "Sky blue",
            fr: "Bleu ciel",
            sp: "Azul celeste",
            it: "Blu cielo",
            nl: "Hemelsblauw",
        },
        {
            RAL: "5017",
            RGB: "006-057-113",
            HEX: "#063971",
            de: "Verkehrsblau",
            en: "Traffic blue",
            fr: "Bleu signalisation",
            sp: "Azul tráfico",
            it: "Blu traffico",
            nl: "Verkeersblauw",
        },
        {
            RAL: "5018",
            RGB: "063-136-143",
            HEX: "#3F888F",
            de: "Türkisblau",
            en: "Turquoise blue",
            fr: "Bleu turquoise",
            sp: "Azul turquesa",
            it: "Blu turchese",
            nl: "Turkooisblauw",
        },
        {
            RAL: "5019",
            RGB: "027-085-131",
            HEX: "#1B5583",
            de: "Capriblau",
            en: "Capri blue",
            fr: "Bleu capri",
            sp: "Azul capri",
            it: "Blu capri",
            nl: "Capriblauw",
        },
        {
            RAL: "5020",
            RGB: "029-051-074",
            HEX: "#1D334A",
            de: "Ozeanblau",
            en: "Ocean blue",
            fr: "Bleu océan",
            sp: "Azul oceano",
            it: "Blu oceano",
            nl: "Oceaanblauw",
        },
        {
            RAL: "5021",
            RGB: "037-109-123",
            HEX: "#256D7B",
            de: "Wasserblau",
            en: "Water blue",
            fr: "Bleu d’eau",
            sp: "Azul agua",
            it: "Blu acqua",
            nl: "Waterblauw",
        },
        {
            RAL: "5022",
            RGB: "037-040-080",
            HEX: "#252850",
            de: "Nachtblau",
            en: "Night blue",
            fr: "Bleu nocturne",
            sp: "Azul noche",
            it: "Blu notte",
            nl: "Nachtblauw",
        },
        {
            RAL: "5023",
            RGB: "073-103-141",
            HEX: "#49678D",
            de: "Fernblau",
            en: "Distant blue",
            fr: "Bleu distant",
            sp: "Azul lejanía",
            it: "Blu distante",
            nl: "Verblauw",
        },
        {
            RAL: "5024",
            RGB: "093-155-155",
            HEX: "#5D9B9B",
            de: "Pastellblau",
            en: "Pastel blue",
            fr: "Bleu pastel",
            sp: "Azul pastel",
            it: "Blu pastello",
            nl: "Pastelblauw",
        },
        /*{
        RAL: "5025",
        RGB: "042-100-120",
        HEX: "#2A6478",
        de: "Perlenzian",
        en: "Pearl gentian blue",
        fr: "Gentiane nacré",
        sp: "Gencian perlado",
        it: "Blu genziana perlato",
        nl: "Parelmoerblauw",
    },*/
        /*{
        RAL: "5026",
        RGB: "016-044-084",
        HEX: "#102C54",
        de: "Perlnachtblau",
        en: "Pearl night blue",
        fr: "Bleu nuit nacré",
        sp: "Azul noche perlado",
        it: "Blu notte perlato",
        nl: "Parelmoer-nachtblauw",
    },*/
        {
            RAL: "6000",
            RGB: "049-102-080",
            HEX: "#316650",
            de: "Patinagrün",
            en: "Patina green",
            fr: "Vert patine",
            sp: "Verde patina",
            it: "Verde patina",
            nl: "Patinagroen",
        },
        {
            RAL: "6001",
            RGB: "040-114-051",
            HEX: "#287233",
            de: "Smaragdgrün",
            en: "Emerald green",
            fr: "Vert émeraude",
            sp: "Verde esmeralda",
            it: "Verde smeraldo",
            nl: "Smaragdgroen",
        },
        {
            RAL: "6002",
            RGB: "045-087-044",
            HEX: "#2D572C",
            de: "Laubgrün",
            en: "Leaf green",
            fr: "Vert feuillage",
            sp: "Verde hoja",
            it: "Verde foglia",
            nl: "Loofgroen",
        },
        {
            RAL: "6003",
            RGB: "066-070-050",
            HEX: "#424632",
            de: "Olivgrün",
            en: "Olive green",
            fr: "Vert olive",
            sp: "Verde oliva",
            it: "Verde oliva",
            nl: "Olijfgroen",
        },
        {
            RAL: "6004",
            RGB: "031-058-061",
            HEX: "#1F3A3D",
            de: "Blaugrün",
            en: "Blue green",
            fr: "Vert bleu",
            sp: "Verde azulado",
            it: "Verde bluastro",
            nl: "Blauwgroen",
        },
        {
            RAL: "6005",
            RGB: "047-069-056",
            HEX: "#2F4538",
            de: "Moosgrün",
            en: "Moss green",
            fr: "Vert mousse",
            sp: "Verde musgo",
            it: "Verde muschio",
            nl: "Mosgroen",
        },
        {
            RAL: "6006",
            RGB: "062-059-050",
            HEX: "#3E3B32",
            de: "Grauoliv",
            en: "Grey olive",
            fr: "Olive gris",
            sp: "Oliva grisáceo",
            it: "Oliva grigiastro",
            nl: "Grijs olijfgroen",
        },
        {
            RAL: "6007",
            RGB: "052-059-041",
            HEX: "#343B29",
            de: "Flaschengrün",
            en: "Bottle green",
            fr: "Vert bouteille",
            sp: "Verde botella",
            it: "Verde bottiglia",
            nl: "Flessegroen",
        },
        {
            RAL: "6008",
            RGB: "057-053-042",
            HEX: "#39352A",
            de: "Braungrün",
            en: "Brown green",
            fr: "Vert brun",
            sp: "Verde parduzco",
            it: "Verde brunastro",
            nl: "Bruingroen",
        },
        {
            RAL: "6009",
            RGB: "049-055-043",
            HEX: "#31372B",
            de: "Tannengrün",
            en: "Fir green",
            fr: "Vert sapin",
            sp: "Verde abeto",
            it: "Verde abete",
            nl: "Dennegroen",
        },
        {
            RAL: "6010",
            RGB: "053-104-045",
            HEX: "#35682D",
            de: "Grasgrün",
            en: "Grass green",
            fr: "Vert herbe",
            sp: "Verde hierba",
            it: "Verde erba",
            nl: "Grasgroen",
        },
        {
            RAL: "6011",
            RGB: "088-114-070",
            HEX: "#587246",
            de: "Resedagrün",
            en: "Reseda green",
            fr: "Vert réséda",
            sp: "Verde reseda",
            it: "Verde reseda",
            nl: "Resedagroen",
        },
        {
            RAL: "6012",
            RGB: "052-062-064",
            HEX: "#343E40",
            de: "Schwarzgrün",
            en: "Black green",
            fr: "Vert noir",
            sp: "Verde negruzco",
            it: "Verde nerastro",
            nl: "Zwartgroen",
        },
        {
            RAL: "6013",
            RGB: "108-113-086",
            HEX: "#6C7156",
            de: "Schilfgrün",
            en: "Reed green",
            fr: "Vert jonc",
            sp: "Verde caña",
            it: "Verde canna",
            nl: "Rietgroen",
        },
        {
            RAL: "6014",
            RGB: "071-064-046",
            HEX: "#47402E",
            de: "Gelboliv",
            en: "Yellow olive",
            fr: "Olive jaune",
            sp: "Amarillo oliva",
            it: "Oliva giallastro",
            nl: "Geel olijfgroen",
        },
        {
            RAL: "6015",
            RGB: "059-060-054",
            HEX: "#3B3C36",
            de: "Schwarzoliv",
            en: "Black olive",
            fr: "Olive noir",
            sp: "Oliva negruzco",
            it: "Oliva nerastro",
            nl: "Zwart olijfgroen",
        },
        {
            RAL: "6016",
            RGB: "030-089-069",
            HEX: "#1E5945",
            de: "Türkisgrün",
            en: "Turquoise green",
            fr: "Vert turquoise",
            sp: "Verde turquesa",
            it: "Verde turchese",
            nl: "Turkooisgroen",
        },
        {
            RAL: "6017",
            RGB: "076-145-065",
            HEX: "#4C9141",
            de: "Maigrün",
            en: "May green",
            fr: "Vert mai",
            sp: "Verde mayo",
            it: "Verde maggio",
            nl: "Meigroen",
        },
        {
            RAL: "6018",
            RGB: "087-166-057",
            HEX: "#57A639",
            de: "Gelbgrün",
            en: "Yellow green",
            fr: "Vert jaune",
            sp: "Verde amarillento",
            it: "Verde giallastro",
            nl: "Geelgroen",
        },
        {
            RAL: "6019",
            RGB: "189-236-182",
            HEX: "#BDECB6",
            de: "Weißgrün",
            en: "Pastel green",
            fr: "Vert blanc",
            sp: "Verde lanquecino",
            it: "Verde biancastro",
            nl: "Witgroen",
        },
        {
            RAL: "6020",
            RGB: "046-058-035",
            HEX: "#2E3A23",
            de: "Chromoxidgrün",
            en: "Chrome green",
            fr: "Vert oxyde chromique",
            sp: "Verde cromo",
            it: "Verde cromo",
            nl: "Chroom-oxydegroen",
        },
        {
            RAL: "6021",
            RGB: "137-172-118",
            HEX: "#89AC76",
            de: "Blassgrün",
            en: "Pale green",
            fr: "Vert pâle",
            sp: "Verde pálido",
            it: "Verde pallido",
            nl: "Bleekgroen",
        },
        {
            RAL: "6022",
            RGB: "037-034-027",
            HEX: "#25221B",
            de: "Braunoliv",
            en: "Olive drab",
            fr: "Olive brun",
            sp: "Oliva parduzco",
            it: "Oliva brunastro",
            nl: "Bruin olijfgroen",
        },
        {
            RAL: "6024",
            RGB: "048-132-070",
            HEX: "#308446",
            de: "Verkehrsgrün",
            en: "Traffic green",
            fr: "Vert signalisation",
            sp: "Verde tráfico",
            it: "Verde traffico",
            nl: "Verkeersgroen",
        },
        {
            RAL: "6025",
            RGB: "061-100-045",
            HEX: "#3D642D",
            de: "Farngrün",
            en: "Fern green",
            fr: "Vert fougère",
            sp: "Verde helecho",
            it: "Verde felce",
            nl: "Varengroen",
        },
        {
            RAL: "6026",
            RGB: "001-093-082",
            HEX: "#015D52",
            de: "Opalgrün",
            en: "Opal green",
            fr: "Vert opale",
            sp: "Verde opalo",
            it: "Verde opale",
            nl: "Opaalgroen",
        },
        {
            RAL: "6027",
            RGB: "132-195-190",
            HEX: "#84C3BE",
            de: "Lichtgrün",
            en: "Light green",
            fr: "Vert clair",
            sp: "Verde luminoso",
            it: "Verde chiaro",
            nl: "Lichtgroen",
        },
        {
            RAL: "6028",
            RGB: "044-085-069",
            HEX: "#2C5545",
            de: "Kieferngrün",
            en: "Pine green",
            fr: "Vert pin",
            sp: "Verde pino",
            it: "Verde pino",
            nl: "Pijnboomgroen",
        },
        {
            RAL: "6029",
            RGB: "032-096-061",
            HEX: "#20603D",
            de: "Minzgrün",
            en: "Mint green",
            fr: "Vert menthe",
            sp: "Verde menta",
            it: "Verde menta",
            nl: "Mintgroen",
        },
        {
            RAL: "6032",
            RGB: "049-127-067",
            HEX: "#317F43",
            de: "Signalgrün",
            en: "Signal green",
            fr: "Vert de sécurité",
            sp: "Verde señales",
            it: "Verde segnale",
            nl: "Signaalgroen",
        },
        {
            RAL: "6033",
            RGB: "073-126-118",
            HEX: "#497E76",
            de: "Minttürkis",
            en: "Mint turquoise",
            fr: "Turquoise menthe",
            sp: "Turquesa menta",
            it: "Turchese menta",
            nl: "Mintturquoise",
        },
        {
            RAL: "6034",
            RGB: "127-181-181",
            HEX: "#7FB5B5",
            de: "Pastelltürkis",
            en: "Pastel turquoise",
            fr: "Turquoise pastel",
            sp: "Turquesa pastel",
            it: "Turchese pastello",
            nl: "Pastelturquoise",
        },
        /*{
        RAL: "6035",
        RGB: "028-084-045",
        HEX: "#1C542D",
        de: "Perlgrün",
        en: "Pearl green",
        fr: "Vert nacré",
        sp: "Verde perlado",
        it: "Verde perlato",
        nl: "Parelmoer-donkergroen",
    },*/
        /*{
        RAL: "6036",
        RGB: "022-053-055",
        HEX: "#193737",
        de: "Perlopalgrün",
        en: "Pearl opal green",
        fr: "Vert opal nacré",
        sp: "Verde ópalo perlado",
        it: "Verde opalo perlato",
        nl: "Parelmoer-lichtgroen",
    },*/
        {
            RAL: "6037",
            RGB: "000-143-057",
            HEX: "#008F39",
            de: "Reingrün",
            en: "Pure green",
            fr: "Vert pur",
            sp: "Verde puro",
            it: "Verde puro",
            nl: "Zuivergroen",
        },
        /*{
        RAL: "6038",
        RGB: "000-187-045",
        HEX: "#00BB2D",
        de: "Leuchtgrün",
        en: "Luminous green",
        fr: "Vert brillant",
        sp: "Verde brillante",
        it: "Verde brillante",
        nl: "Briljantgroen",
    },*/
        {
            RAL: "7000",
            RGB: "120-133-139",
            HEX: "#78858B",
            de: "Fehgrau",
            en: "Squirrel grey",
            fr: "Gris petit-gris",
            sp: "Gris ardilla",
            it: "Grigio vaio",
            nl: "Pelsgrijs",
        },
        {
            RAL: "7001",
            RGB: "138-149-151",
            HEX: "#8A9597",
            de: "Silbergrau",
            en: "Silver grey",
            fr: "Gris argent",
            sp: "Gris plata",
            it: "Grigio argento",
            nl: "Zilvergrijs",
        },
        {
            RAL: "7002",
            RGB: "126-123-082",
            HEX: "#7E7B52",
            de: "Olivgrau",
            en: "Olive grey",
            fr: "Gris olive",
            sp: "Gris oliva",
            it: "Grigio olivastro",
            nl: "Olijfgrijs",
        },
        {
            RAL: "7003",
            RGB: "108-112-089",
            HEX: "#6C7059",
            de: "Moosgrau",
            en: "Moss grey",
            fr: "Gris mousse",
            sp: "Gris musgo",
            it: "Grigio muschio",
            nl: "Mosgrijs",
        },
        {
            RAL: "7004",
            RGB: "150-153-146",
            HEX: "#969992",
            de: "Signalgrau",
            en: "Signal grey",
            fr: "Gris de sécurité",
            sp: "Gris señales",
            it: "Grigio segnale",
            nl: "Signaalgrijs",
        },
        {
            RAL: "7005",
            RGB: "100-107-099",
            HEX: "#646B63",
            de: "Mausgrau",
            en: "Mouse grey",
            fr: "Gris souris",
            sp: "Gris ratón",
            it: "Grigio topo",
            nl: "Muisgrijs",
        },
        {
            RAL: "7006",
            RGB: "109-101-082",
            HEX: "#6D6552",
            de: "Beigegrau",
            en: "Beige grey",
            fr: "Gris beige",
            sp: "Gris beige",
            it: "Grigio beige",
            nl: "Beigegrijs",
        },
        {
            RAL: "7008",
            RGB: "106-095-049",
            HEX: "#6A5F31",
            de: "Khakigrau",
            en: "Khaki grey",
            fr: "Gris kaki",
            sp: "Gris caqui",
            it: "Grigio kaki",
            nl: "Kakigrijs",
        },
        {
            RAL: "7009",
            RGB: "077-086-069",
            HEX: "#4D5645",
            de: "Grüngrau",
            en: "Green grey",
            fr: "Gris vert",
            sp: "Gris verdoso",
            it: "Grigio verdastro",
            nl: "Groengrijs",
        },
        {
            RAL: "7010",
            RGB: "076-081-074",
            HEX: "#4C514A",
            de: "Zeltgrau",
            en: "Tarpaulin grey",
            fr: "Gris tente",
            sp: "Gris lona",
            it: "Grigio tenda",
            nl: "Zeildoekgrijs",
        },
        {
            RAL: "7011",
            RGB: "067-075-077",
            HEX: "#434B4D",
            de: "Eisengrau",
            en: "Iron grey",
            fr: "Gris fer",
            sp: "Gris hierro",
            it: "Grigio ferro",
            nl: "IJzergrijs",
        },
        {
            RAL: "7012",
            RGB: "078-087-084",
            HEX: "#4E5754",
            de: "Basaltgrau",
            en: "Basalt grey",
            fr: "Gris basalte",
            sp: "Gris basalto",
            it: "Grigio basalto",
            nl: "Bazaltgrijs",
        },
        {
            RAL: "7013",
            RGB: "070-069-049",
            HEX: "#464531",
            de: "Braungrau",
            en: "Brown grey",
            fr: "Gris brun",
            sp: "Gris parduzco",
            it: "Grigio brunastro",
            nl: "Bruingrijs",
        },
        {
            RAL: "7015",
            RGB: "067-071-080",
            HEX: "#434750",
            de: "Schiefergrau",
            en: "Slate grey",
            fr: "Gris ardoise",
            sp: "Gris pizarra",
            it: "Grigio ardesia",
            nl: "Leigrijs",
        },
        {
            RAL: "7016",
            RGB: "041-049-051",
            HEX: "#293133",
            de: "Anthrazitgrau",
            en: "Anthracite grey",
            fr: "Gris anthracite",
            sp: "Gris antracita",
            it: "Grigio antracite",
            nl: "Antracietgrijs",
        },
        {
            RAL: "7021",
            RGB: "035-040-043",
            HEX: "#23282B",
            de: "Schwarzgrau",
            en: "Black grey",
            fr: "Gris noir",
            sp: "Gris negruzco",
            it: "Grigio nerastro",
            nl: "Zwartgrijs",
        },
        {
            RAL: "7022",
            RGB: "051-047-044",
            HEX: "#332F2C",
            de: "Umbragrau",
            en: "Umbra grey",
            fr: "Gris terre d’ombre",
            sp: "Gris sombra",
            it: "Grigio ombra",
            nl: "Ombergrijs",
        },
        {
            RAL: "7023",
            RGB: "104-108-094",
            HEX: "#686C5E",
            de: "Betongrau",
            en: "Concrete grey",
            fr: "Gris béton",
            sp: "Gris hormigón",
            it: "Grigio calcestruzzo",
            nl: "Betongrijs",
        },
        {
            RAL: "7024",
            RGB: "071-074-081",
            HEX: "#474A51",
            de: "Graphitgrau",
            en: "Graphite grey",
            fr: "Gris graphite",
            sp: "Gris grafita",
            it: "Grigio grafite",
            nl: "Grafietgrijs",
        },
        {
            RAL: "7026",
            RGB: "047-053-059",
            HEX: "#2F353B",
            de: "Granitgrau",
            en: "Granite grey",
            fr: "Gris granit",
            sp: "Gris granito",
            it: "Grigio granito",
            nl: "Granietgrijs",
        },
        {
            RAL: "7030",
            RGB: "139-140-122",
            HEX: "#8B8C7A",
            de: "Steingrau",
            en: "Stone grey",
            fr: "Gris pierre",
            sp: "Gris piedra",
            it: "Grigio pietra",
            nl: "Steengrijs",
        },
        {
            RAL: "7031",
            RGB: "071-075-078",
            HEX: "#474B4E",
            de: "Blaugrau",
            en: "Blue grey",
            fr: "Gris bleu",
            sp: "Gris azulado",
            it: "Grigio bluastro",
            nl: "Blauwgrijs",
        },
        {
            RAL: "7032",
            RGB: "184-183-153",
            HEX: "#B8B799",
            de: "Kieselgrau",
            en: "Pebble grey",
            fr: "Gris silex",
            sp: "Gris guijarro",
            it: "Grigio ghiaia",
            nl: "Kiezelgrijs",
        },
        {
            RAL: "7033",
            RGB: "125-132-113",
            HEX: "#7D8471",
            de: "Zementgrau",
            en: "Cement grey",
            fr: "Gris ciment",
            sp: "Gris cemento",
            it: "Grigio cemento",
            nl: "Cementgrijs",
        },
        {
            RAL: "7034",
            RGB: "143-139-102",
            HEX: "#8F8B66",
            de: "Gelbgrau",
            en: "Yellow grey",
            fr: "Gris jaune",
            sp: "Gris amarillento",
            it: "Grigio giallastro",
            nl: "Geelgrijs",
        },
        {
            RAL: "7035",
            RGB: "215-215-215",
            HEX: "#D7D7D7",
            de: "Lichtgrau",
            en: "Light grey",
            fr: "Gris clair",
            sp: "Gris luminoso",
            it: "Grigio luce",
            nl: "Lichtgrijs",
        },
        {
            RAL: "7036",
            RGB: "127-118-121",
            HEX: "#7F7679",
            de: "Platingrau",
            en: "Platinum grey",
            fr: "Gris platine",
            sp: "Gris platino",
            it: "Grigio platino",
            nl: "Platinagrijs",
        },
        {
            RAL: "7037",
            RGB: "125-127-120",
            HEX: "#7D7F7D",
            de: "Staubgrau",
            en: "Dusty grey",
            fr: "Gris poussière",
            sp: "Gris polvo",
            it: "Grigio polvere",
            nl: "Stofgrijs",
        },
        {
            RAL: "7038",
            RGB: "195-195-195",
            HEX: "#B5B8B1",
            de: "Achatgrau",
            en: "Agate grey",
            fr: "Gris agate",
            sp: "Gris ágata",
            it: "Grigio agata",
            nl: "Agaatgrijs",
        },
        {
            RAL: "7039",
            RGB: "108-105-096",
            HEX: "#6C6960",
            de: "Quarzgrau",
            en: "Quartz grey",
            fr: "Gris quartz",
            sp: "Gris cuarzo",
            it: "Grigio quarzo",
            nl: "Kwartsgrijs",
        },
        {
            RAL: "7040",
            RGB: "157-161-170",
            HEX: "#9DA1AA",
            de: "Fenstergrau",
            en: "Window grey",
            fr: "Gris fenêtre",
            sp: "Gris ventana",
            it: "Grigio finestra",
            nl: "Venstergrijs",
        },
        {
            RAL: "7042",
            RGB: "141-148-141",
            HEX: "#8D948D",
            de: "Verkehrsgrau A",
            en: "Traffic grey A",
            fr: "Gris signalisation A",
            sp: "Gris tráfico A",
            it: "Grigio traffico A",
            nl: "Verkeesgrijs A",
        },
        {
            RAL: "7043",
            RGB: "078-084-082",
            HEX: "#4E5452",
            de: "Verkehrsgrau B",
            en: "Traffic grey B",
            fr: "Gris signalisation B",
            sp: "Gris tráfico B",
            it: "Grigio traffico B",
            nl: "Verkeersgrijs B",
        },
        {
            RAL: "7044",
            RGB: "202-196-176",
            HEX: "#CAC4B0",
            de: "Seidengrau",
            en: "Silk grey",
            fr: "Gris soie",
            sp: "Gris seda",
            it: "Grigio seta",
            nl: "Zijdegrijs",
        },
        {
            RAL: "7045",
            RGB: "144-144-144",
            HEX: "#909090",
            de: "Telegrau 1",
            en: "Telegrey 1",
            fr: "Telegris 1",
            sp: "Gris tele 1",
            it: "Tele grigio 1",
            nl: "Telegrijs 1",
        },
        {
            RAL: "7046",
            RGB: "130-137-143",
            HEX: "#82898F",
            de: "Telegrau 2",
            en: "Telegrey 2",
            fr: "Telegris 2",
            sp: "Gris tele 2",
            it: "Tele grigio 2",
            nl: "Telegrijs 2",
        },
        {
            RAL: "7047",
            RGB: "208-208-208",
            HEX: "#D0D0D0",
            de: "Telegrau 4",
            en: "Telegrey 4",
            fr: "Telegris 4",
            sp: "Gris tele 4",
            it: "Tele grigio 4",
            nl: "Telegrijs 4",
        },
        {
            RAL: "7048",
            RGB: "137-129-118",
            HEX: "#898176",
            de: "Perlmausgrau",
            en: "Pearl mouse grey",
            fr: "Gris souris nacré",
            sp: "Gris musgo perlado",
            it: "Grigio topo perlato",
            nl: "Parelmoer-muisgrijs",
        },
        {
            RAL: "8000",
            RGB: "130-108-052",
            HEX: "#826C34",
            de: "Grünbraun",
            en: "Green brown",
            fr: "Brun vert",
            sp: "Pardo verdoso",
            it: "Marrone verdastro",
            nl: "Groenbruin",
        },
        {
            RAL: "8001",
            RGB: "149-095-032",
            HEX: "#955F20",
            de: "Ockerbraun",
            en: "Ochre brown",
            fr: "Brun terre de Sienne",
            sp: "Pardo ocre",
            it: "Marrone ocra",
            nl: "Okerbruin",
        },
        {
            RAL: "8002",
            RGB: "108-059-042",
            HEX: "#6C3B2A",
            de: "Signalbraun",
            en: "Signal brown",
            fr: "Brun de sécurité",
            sp: "Marrón señales",
            it: "Marrone segnale",
            nl: "Signaalbruin",
        },
        {
            RAL: "8003",
            RGB: "115-066-034",
            HEX: "#734222",
            de: "Lehmbraun",
            en: "Clay brown",
            fr: "Brun argile",
            sp: "Pardo arcilla",
            it: "Marrone fango",
            nl: "Leembruin",
        },
        {
            RAL: "8004",
            RGB: "142-064-042",
            HEX: "#8E402A",
            de: "Kupferbraun",
            en: "Copper brown",
            fr: "Brun cuivré",
            sp: "Pardo cobre",
            it: "Marrone rame",
            nl: "Koperbruin",
        },
        {
            RAL: "8007",
            RGB: "089-053-031",
            HEX: "#59351F",
            de: "Rehbraun",
            en: "Fawn brown",
            fr: "Brun fauve",
            sp: "Pardo corzo",
            it: "Marrone capriolo",
            nl: "Reebruin",
        },
        {
            RAL: "8008",
            RGB: "111-079-040",
            HEX: "#6F4F28",
            de: "Olivbraun",
            en: "Olive brown",
            fr: "Brun olive",
            sp: "Pardo oliva",
            it: "Marrone oliva",
            nl: "Olijfbruin",
        },
        {
            RAL: "8011",
            RGB: "091-058-041",
            HEX: "#5B3A29",
            de: "Nussbraun",
            en: "Nut brown",
            fr: "Brun noisette",
            sp: "Pardo nuez",
            it: "Marrone noce",
            nl: "Notebruin",
        },
        {
            RAL: "8012",
            RGB: "089-035-033",
            HEX: "#592321",
            de: "Rotbraun",
            en: "Red brown",
            fr: "Brun rouge",
            sp: "Pardo rojo",
            it: "Marrone rossiccio",
            nl: "Roodbruin",
        },
        {
            RAL: "8014",
            RGB: "056-044-030",
            HEX: "#382C1E",
            de: "Sepiabraun",
            en: "Sepia brown",
            fr: "Brun sépia",
            sp: "Sepia",
            it: "Marrone seppia",
            nl: "Sepiabruin",
        },
        {
            RAL: "8015",
            RGB: "099-058-052",
            HEX: "#633A34",
            de: "Kastanienbraun",
            en: "Chestnut brown",
            fr: "Marron",
            sp: "Castaño",
            it: "Marrone castagna",
            nl: "Kastanjebruin",
        },
        {
            RAL: "8016",
            RGB: "076-047-039",
            HEX: "#4C2F27",
            de: "Mahagonibraun",
            en: "Mahogany brown",
            fr: "Brun acajou",
            sp: "Caoba",
            it: "Marrone mogano",
            nl: "Mahoniebruin",
        },
        {
            RAL: "8017",
            RGB: "069-050-046",
            HEX: "#45322E",
            de: "Schokoladen-braun",
            en: "Chocolate brown",
            fr: "Brun chocolat",
            sp: "Chocolate",
            it: "Marrone cioccolata",
            nl: "Chocoladebruin",
        },
        {
            RAL: "8019",
            RGB: "064-058-058",
            HEX: "#403A3A",
            de: "Graubraun",
            en: "Grey brown",
            fr: "Brun gris",
            sp: "Pardo grisáceo",
            it: "Marrone grigiastro",
            nl: "Grijsbruin",
        },
        {
            RAL: "8022",
            RGB: "033-033-033",
            HEX: "#212121",
            de: "Schwarzbraun",
            en: "Black brown",
            fr: "Brun noir",
            sp: "Pardo negruzco",
            it: "Marrone nerastro",
            nl: "Zwartbruin",
        },
        {
            RAL: "8023",
            RGB: "166-094-046",
            HEX: "#A65E2E",
            de: "Orangebraun",
            en: "Orange brown",
            fr: "Brun orangé",
            sp: "Pardo anaranjado",
            it: "Marrone arancio",
            nl: "Oranjebruin",
        },
        {
            RAL: "8024",
            RGB: "121-085-061",
            HEX: "#79553D",
            de: "Beigebraun",
            en: "Beige brown",
            fr: "Brun beige",
            sp: "Pardo beige",
            it: "Marrone beige",
            nl: "Beigebruin",
        },
        {
            RAL: "8025",
            RGB: "117-092-072",
            HEX: "#755C48",
            de: "Blassbraun",
            en: "Pale brown",
            fr: "Brun pâle",
            sp: "Pardo pálido",
            it: "Marrone pallido",
            nl: "Bleekbruin",
        },
        {
            RAL: "8028",
            RGB: "078-059-049",
            HEX: "#4E3B31",
            de: "Terrabraun",
            en: "Terra brown",
            fr: "Brun terre",
            sp: "Marrón tierra",
            it: "Marrone terra",
            nl: "Terrabruin",
        },
        /*{
        RAL: "8029",
        RGB: "118-060-040",
        HEX: "#763C28",
        de: "Perlkupfer",
        en: "Pearl copper",
        fr: "Cuivre nacré",
        sp: "Cobre perlado",
        it: "Rame perlato",
        nl: "Parelmoerkoper",
    },*/
        {
            RAL: "9001",
            RGB: "250-244-227",
            HEX: "#FDF4E3",
            de: "Cremeweiß",
            en: "Cream",
            fr: "Blanc crème",
            sp: "Blanco crema",
            it: "Bianco crema",
            nl: "Crèmewit",
        },
        {
            RAL: "9002",
            RGB: "231-235-218",
            HEX: "#E7EBDA",
            de: "Grauweiß",
            en: "Grey white",
            fr: "Blanc gris",
            sp: "Blanco grisáceo",
            it: "Bianco grigiastro",
            nl: "Grijswit",
        },
        {
            RAL: "9003",
            RGB: "244-244-244",
            HEX: "#F4F4F4",
            de: "Signalweiß",
            en: "Signal white",
            fr: "Blanc de sécurité",
            sp: "Blanco señales",
            it: "Bianco segnale",
            nl: "Signaalwit",
        },
        {
            RAL: "9004",
            RGB: "040-040-040",
            HEX: "#282828",
            de: "Signalschwarz",
            en: "Signal black",
            fr: "Noir de sécurité",
            sp: "Negro señales",
            it: "Nero segnale",
            nl: "Signaalzwart",
        },
        {
            RAL: "9005",
            RGB: "010-010-013",
            HEX: "#0A0A0A",
            de: "Tiefschwarz",
            en: "Jet black",
            fr: "Noir foncé",
            sp: "Negro intenso",
            it: "Nero intenso",
            nl: "Gitzwart",
        },
        {
            RAL: "9006",
            RGB: "165-165-165",
            HEX: "#A5A5A5",
            de: "Weißaluminium",
            en: "White aluminium",
            fr: "Aluminium blanc",
            sp: "Aluminio blanco",
            it: "Aluminio brillante",
            nl: "Blank aluminiumkleurig",
        },
        {
            RAL: "9007",
            RGB: "143-143-143",
            HEX: "#8F8F8F",
            de: "Graualuminium",
            en: "Grey aluminium",
            fr: "Aluminium gris",
            sp: "Aluminio gris",
            it: "Aluminio grigiastro",
            nl: "Grijs aluminiumkleurig",
        },
        {
            RAL: "9010",
            RGB: "255-255-255",
            HEX: "#FFFFFF",
            de: "Reinweiß",
            en: "Pure white",
            fr: "Blanc pur",
            sp: "Blanco puro",
            it: "Bianco puro",
            nl: "Zuiverwit",
        },
        {
            RAL: "9011",
            RGB: "028-028-028",
            HEX: "#1C1C1C",
            de: "Graphitschwarz",
            en: "Graphite black",
            fr: "Noir graphite",
            sp: "Negro grafito",
            it: "Nero grafite",
            nl: "Grafietzwart",
        },
        {
            RAL: "9016",
            RGB: "246-246-246",
            HEX: "#F6F6F6",
            de: "Verkehrsweiß",
            en: "Traffic white",
            fr: "Blanc signalisation",
            sp: "Blanco tráfico",
            it: "Bianco traffico",
            nl: "Verkeerswit",
        },
        {
            RAL: "9017",
            RGB: "030-030-030",
            HEX: "#1E1E1E",
            de: "Verkehrs-schwarz",
            en: "Traffic black",
            fr: "Noir signalisation",
            sp: "Negro tráfico",
            it: "Nero traffico",
            nl: "Verkeerszwart",
        },
        {
            RAL: "9018",
            RGB: "215-215-215",
            HEX: "#D7D7D7",
            de: "Papyrusweiß",
            en: "Papyrus white",
            fr: "Blanc papyrus",
            sp: "Blanco papiro",
            it: "Bianco papiro",
            nl: "Papyruswit",
        },
        /*{
        RAL: "9022",
        RGB: "156-156-156",
        HEX: "#9C9C9C",
        de: "Perlhellgrau",
        en: "Pearl light grey",
        fr: "Gris clair nacré",
        sp: "Gris claro perlado",
        it: "Grigio chiaro perlato",
        nl: "Parelmoer-lichtgrijs",
    },*/
        /*{
        RAL: "9023",
        RGB: "130-130-130",
        HEX: "#828282",
        de: "Perldunkelgrau",
        en: "Pearl dark grey",
        fr: "Gris fonçé nacré",
        sp: "Gris oscuro perlado",
        it: "Grigio scuro perlato",
        nl: "Parelmoer-donkergrijs",
    },*/
    ],
}
